export const additionalServicesBasedOnLocation = {
	Trondheim: {
		PlussLite: [],
		PlussStor: [],
		Signatur: [],
	},
	Molde: {
		PlussStor: [],
		Signatur: [],
	},
	Ålesund: {
		PlussStor: [],
		Signatur: [],
	},
	Hamar: {
		PlussLite: [],
		PlussStor: [],
		Signatur: [],
	},
	Oslo: {},
	Stavanger: {},
};

export const commonPackages = {
	Basis: [
		{
			id: 'jobbkarusell',
			name: 'Jobbkarusell Fra 2600,-',
		}
	],
	PlussLite: [],
	Signatur: [
		{
			id: 'podcast',
			name: 'Podcast',
			subPackages: [
				{
					id: 'video',
					name: 'Video',
				},
				{
					id: 'lyd',
					name: 'Lyd',
				}
			]
		},
		{
			id: 'innhold',
			name: 'Innhold',
		}
	],
};
